import { Alert, Box, Container, Grid, Typography } from '@mui/material'
import { useAuthenticatedMutation, useAuthenticatedQuery } from 'csam/api/api'
import PageLoader from 'csam/components/common/PageLoader'
import Headerdark from 'csam/components/HeaderDark'
import LocaleContext from 'csam/components/LocaleContext'
import InnerPageWrapper from 'csam/theme/InnerPageWrapper'
import PageBanner from 'csam/theme/PageBanner'
import PageHeadingTypography from 'csam/theme/PageHeadingTypography'
import { fixed, getImage, localImages } from 'csam/utils/Constants'
import InternalServerError from './InternalServerError'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation} from 'swiper/modules'
import 'swiper/css';
import 'swiper/css/navigation';
import GamesContestsTranslations from 'csam/translations/GamesContestsTranslations'
import React, { useEffect } from 'react'


export interface GamesData {
    id: number;
    game_title: string;
    image: string;
    link: string;
}

export interface QuizData {
    id: number;
    name: string;
    image: string;
    description: string;
    imgage: string;
}

interface GamesContestsPageData {
    success: boolean;
    gamesData: GamesData[];
    quizData: QuizData;
}

interface Question {
    id: number;
    text: string;
    questions_options: [];
}

const styles = {
  swiperWrapper: {
     

    '.swiper-button-next, .swiper-button-prev': {
      color: '#D3A238',
      width: '25px',
      height: '50px',
    },
    '.swiper-button-next::after, .swiper-button-prev::after': {
      fontSize: '25px',
      fontWeight: 'bold',
    },

    '.swiper-button-prev': {
      left: '-6px',   // move arrow further left
      top:'50%'
    },

    '.swiper-button-next': {
        right: '-6px',
        top:'50%'  // move arrow further right
    },
  },
};

const CyberChallenge: React.FC = () => {
    const pageName = 'Games & Contests';
    const encodedPage = encodeURIComponent(pageName);
    const { locale } = React.useContext(LocaleContext);
    const localeFromStorage = localStorage.getItem('locale') || 'en';

    const getTranslation = (key: keyof (typeof GamesContestsTranslations)['en']) =>
        GamesContestsTranslations[localeFromStorage as keyof typeof GamesContestsTranslations]?.[key] ||
        GamesContestsTranslations.en[key];


    const { isPending, error, data } = useAuthenticatedQuery<GamesContestsPageData>(['GamesContests', locale], {
        url: `${fixed}crud/${localeFromStorage || locale}/games-contests?page=${encodedPage}`,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    });

    const pageLandingMutation = useAuthenticatedMutation(['post-page-activity', 'PostData'], (postData) => ({
        url: `${fixed}crud/user-page-landing-activity`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: postData,
    }));

    useEffect(() => {
        const postData = { pageName: pageName };
        pageLandingMutation.mutate(postData);
    }, []);

    if (isPending) return <PageLoader />;
    if (error) return <div>Error: {error.message}</div>;
    if (!data || !data.success || !data.data) return <InternalServerError />;

    const { gamesData, quizData } = data.data;

    console.log('games and quiz data', gamesData, quizData);

    const openQuizPage = (id: number) => {
        let localeValue = localeFromStorage;
        localeValue = localeValue.endsWith('/') ? localeValue.slice(0, -1) : localeValue;
        window.open(`/${localeValue}/play-quiz?id=${id}`, '_blank');
    };

    const openGamePage = (link: string) => {
        let localeValue = localeFromStorage;
        localeValue = localeValue.endsWith('/') ? localeValue.slice(0, -1) : localeValue;
        window.open(`/${localeValue}/game-page?link=${link}`, '_blank');
    };

    return (
        <>
            <InnerPageWrapper
                backgroundImage={`${localImages}inner_bg_full_page.jpg`}
                backgroundPosition="0 -36px"
                height="100vh"
                overlay
                overlayColor="#000000B2"
                className='innerPageWrapper'
                overlayOpacity={0.5}
            >
                <Headerdark />
                <Container sx={{ height: '87%' }}>
                    <Grid sx={{ height: '100%' }} container>
                        <Grid sx={{ height: '100%' }} item sm={4.4} >
                            <PageBanner
                                title={getTranslation('bannerHeading')}
                                highlightedText={getTranslation('bannerSubHeading')}
                                description={getTranslation('bannerContent')}
                                backgroundImage={`${localImages}cyber_challenge_bg.png`}
                                overlay={{
                                    color: "#1E1F1D",
                                    opacity: 0.7
                                }}

                            />
                        </Grid>
                        <Grid item sm={7.6} sx={{ padding: { xs: 0, sm: 2 }, }}>
                            <PageHeadingTypography>{getTranslation('tab1')}</PageHeadingTypography>

                            <Box sx={{ position: 'relative',...styles.swiperWrapper }} className="swiper_mob_responsive">
                                {Array.isArray(quizData) && quizData.length > 0 ? (
                                    <>
                                        <Swiper
                                            slidesPerView={2}
                                            spaceBetween={10}
                                            loop={true}
                                            autoplay={{ delay: 6000, disableOnInteraction: false }}
                                            pagination={{ clickable: true }}
                                            navigation
                                            modules={[Autoplay,Navigation]}
                                            breakpoints={{
                                                0: {
                                                    slidesPerView: 1,
                                                    spaceBetween: 8,
                                                },
                                                600: {
                                                    slidesPerView: 1,
                                                    spaceBetween: 10,
                                                },
                                                900: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 16,
                                                },
                                                1200: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 24,
                                                },
                                            }}
                                            style={{ width: '100%' }}
                                        >
                                            {quizData.map((quiz) => {
                                                const hasQuestions = quiz.quiz_questions && quiz.quiz_questions.length > 0;
                                                const allQuestionsHaveOptions =
                                                    hasQuestions &&
                                                    quiz.quiz_questions.every(
                                                        (question: Question) => question.questions_options && question.questions_options.length > 0,
                                                    );

                                                if (!hasQuestions || !allQuestionsHaveOptions) {
                                                    return null;
                                                }

                                                return (
                                                    <SwiperSlide key={quiz.id}>
                                                        <Box className="cardArticles" sx={{ padding: '15px', background: 'linear-gradient(332deg, #959b7a99 9%, #24251e 57%)', borderRadius: '13px', cursor: 'pointer' }} onClick={() => openQuizPage(quiz.id)} >
                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0' }}>
                                                                <Typography variant='body1' sx={{ fontSize: '16px', fontWeight: 600, color: '#D3A238', lineHeight: '16px' }}>
                                                                    <img src="" alt="" />
                                                                    {quiz.name}
                                                                </Typography>
                                                            </Box>
                                                            <Typography variant='body1' sx={{ fontSize: '14px', lineHeight: '16px', color: '#ECECEC', mb: 2 }}>{quiz.description}</Typography>
                                                            <img width='100%' height='150px' style={{ objectFit: 'cover' }} src={`${getImage}quiz_contests/${quiz.image}`} alt="Quiz" />
                                                        </Box>

                                                    </SwiperSlide>
                                                );
                                            })}
                                        </Swiper>
                                    </>
                                ) : (
                                    <Grid container>
                                        <Grid item sm={12}>
                                            <Alert severity="warning" sx={{ fontSize: '18px', justifyContent: 'center' }}>
                                                We apologize, but there are no quizzes available at the moment. Please check back later for new quizzes!
                                            </Alert>
                                        </Grid>
                                    </Grid>
                                )}
                            </Box>

                            <hr />

                            <PageHeadingTypography>{getTranslation('tab2')}</PageHeadingTypography>

                            <Box sx={{ position: 'relative',...styles.swiperWrapper }} className="swiper_mob_responsive">
                                {Array.isArray(gamesData) && gamesData.length > 0 ? (
                                    <>
                                        <Swiper
                                            slidesPerView={2}
                                            spaceBetween={10}
                                            loop={true}
                                            autoplay={{ delay: 6000, disableOnInteraction: false }}
                                            pagination={{ clickable: true }}
                                            navigation
                                            modules={[Autoplay,Navigation]}
                                            breakpoints={{
                                                0: {
                                                    slidesPerView: 1,
                                                    spaceBetween: 8,
                                                },
                                                600: {
                                                    slidesPerView: 1,
                                                    spaceBetween: 10,
                                                },
                                                900: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 16,
                                                },
                                                1200: {
                                                    slidesPerView: 2,
                                                    spaceBetween: 24,
                                                },
                                            }}
                                        >
                                            {gamesData.map((item) => (
                                                <SwiperSlide key={item.id}>
                                                    <Box className="cardArticles" sx={{ padding: '15px', background: 'linear-gradient(332deg, #959b7a99 9%, #24251e 57%)', borderRadius: '13px', cursor: 'pointer' }} onClick={() => openGamePage(item.link)}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 0' }}>
                                                            <Typography variant='body1' sx={{ fontSize: '16px', fontWeight: 600, color: '#D3A238', lineHeight: '16px' }}>
                                                                {item.game_title}
                                                            </Typography>
                                                        </Box>
                                                        <img
                                                            width='100%'
                                                            height='200px'
                                                            style={{ objectFit: 'cover' }}
                                                            src={`${getImage}games/${item.image}`}
                                                            alt="Game Thumbnail"

                                                        />
                                                    </Box>
                                                </SwiperSlide>
                                            ))}
                                        </Swiper>
                                    </>
                                ) : (
                                    <Grid container>
                                        <Grid item sm={12}>
                                            <Alert severity="warning" sx={{ fontSize: '18px', justifyContent: 'center' }}>
                                                We apologize, but there are no games available at the moment. Please check back later for new games!
                                            </Alert>
                                        </Grid>
                                    </Grid>
                                )}
                            </Box>

                        </Grid>
                    </Grid>
                </Container>
            </InnerPageWrapper>

        </>
    )
}

export default CyberChallenge
